import React, { useState, useContext } from 'react';
import { FormElement, InputBox } from "../../../common/styled-components/styled-components"
import { useEffect } from 'react';
import { SetGradeApi, ValidateOfferCode, grantProductAccess } from "../../../../../app/js/services/parent-api"
import { getTrialEndDate } from "../../../../../app/js/utils/web-helper"
import * as S from "./style";
import { mintGreen } from '../../../../../app/js/components/loggedout/shared-styles/Colors';
import Image from '../../../../../app/js/components/loggedout/common/Image';
import tick from "~images/sem/tick.png";
import { convertSecondsToDays } from '../../../../../app/js_bytesize/templates/purchase/pricing-helper';
import { SemContext } from "../../../context/SemContext"
import { GuestUserCreation } from '../../../../../app/js/services/loggedout-api';
import OnboardingAnimation from '../../../common/animation/animation-components/OnboardingAnimation';

const Promo = ({ selectedPlan }) => {
  let [promo, setPromo] = useState("");
  let [error, setError] = useState({});
  let [email, setEmail] = useState("");
  let [isButtonDisabled, setIsButtonDisabled] = useState(true);
  let [promoValid, setPromoValid] = useState(false);
  const { state } = useContext(SemContext);
  const campaign_code = localStorage.getItem("campaign_code");
  const type = "Without Credit Card";
  const trialPeriod = convertSecondsToDays(selectedPlan && selectedPlan.access_duration);
  const promoValidMessage = `Congratulations! You now have unlimited access to SplashLearn till ${getTrialEndDate(trialPeriod)}`;
  const variant = localStorage.getItem("sem_variant") || state.variant;
  const [showOnboardingAnimation, setShowOnboardingAnimation] = useState(false);

  const sendEvent = (eventName, eventProps) => {
    trackAnalyticsEvent(eventName, {
      'Landing Page': variant,
      ...(campaign_code && campaign_code != "undefined" && { campaign_code }),
      type,
      ...eventProps
    })
  }

  const handleSubmit = e => {
    e.preventDefault();

    sendEvent('Promo Code Page Interacted', {
      "Clicked On": "Get Started"
    })

    if (validateForm()) {
      settingUpUser();
    }
  }

  const settingUpUser = async (params = {}) => {
    const val = state.settings.show_promo_popup === 'true' ? true : await validatePromoCode();
    if (val) {
      const campaign_code = localStorage.getItem("campaign_code");

      try {
        //Creating Parent user by overriding user parameter
        const userCreation = await GuestUserCreation({
          user: {
            type: "parent",
            email: email
          },
          fromSemLandingPage: true,
          rejectWithErrorObject: true,
          variant: variant,
          ...(campaign_code != "undefined" && { source: campaign_code })
        })

        if(state.settings.show_promo_popup === 'true') {
          setShowOnboardingAnimation(true);
        }

        const response = await SetGradeApi({
          grade_code: state.grade,
          student_id: null,
          onboarding: true,
          password_not_set: true,
        })

        let grantProductAccessParams = {
          source: campaign_code,
        }

        if ( state.settings.show_promo_popup === 'true') {
          grantProductAccessParams = {...grantProductAccessParams, code: state.promoCode, product_code: state.products[0].code};
          if (state.coupons.length !== 0) {
            grantProductAccessParams = {...grantProductAccessParams, coupon_code: state.coupons[0].stripe_id};
          }
        }
        else {
          grantProductAccessParams = {...grantProductAccessParams, code: promo};
        }

        const productAccess = await grantProductAccess(grantProductAccessParams)

        location.href = "/parent-dashboard/#set-password";
      }

      catch (err) {
        const errMsg = err && err.errors && err.errors[0] || err.msg || "Something went wrong, please try again";
        sendEvent("Error on Promo Code Page Shown", { "Error Message": errMsg })
        setError({ ...error, email: "", promo: "", formError: errMsg })
        console.error(err);
        if(state.settings.show_promo_popup === 'true') {
          setShowOnboardingAnimation(false);
        }
      }
    }
  }

  const validateForm = () => {
    let emailErr = ""

    if (!email || email && email.trim().length == 0)
      emailErr = "Email can't be blank";

    else if (email) {
      const emailRegex = /^[a-zA-Z0-9,!#\$%&'\*\+\/=\?\^_`\{\|}~-]+(\.[a-zA-Z0-9,!#\$%&'\*\+\/=\?\^_`\{\|}~-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.([a-zA-Z]{2,})$/;

      if (!emailRegex.test(email)) {
        emailErr = "Email is invalid";
        sendEvent('Error on Promo Code Page Shown', {
          "Error Type": "Invalid Email"
        })
      }
    }

    setError({ ...error, email: emailErr });

    return !emailErr
  }

  const validatePromoCode = async e => {
    e && e.preventDefault();

    e && sendEvent('Promo Code Page Interacted', {
      "Clicked On": error.promo ? "Try Again" : "Apply"
    })

    if (!promo) {
      sendEvent('Error on Promo Code Page Shown', { "Error Type": "Invalid Promo Code" })
      setError({ ...error, promo: "Invalid Promo Code" });
      return false;
    }

    const resp = await ValidateOfferCode({ code: promo });

    if (resp && resp.valid == true) {
      setPromoValid(true);
      setError({ ...error, promo: "" });
      return true;
    }

    else {
      sendEvent('Error on Promo Code Page Shown', { "Error Type": "Invalid Promo Code" })
      setPromoValid(false);
      setError({ ...error, promo: "Invalid Promo Code" });
      return false;
    }
  }

  useEffect(() => {
    if ( state.settings.show_promo_popup === 'true') {
      setPromo(state.promoCode);
    }
    sendEvent('Promo Code Page Viewed ', {});
  }, [])

  useEffect(() => {
    if (state.settings.show_promo_popup === 'true' && email) {
      setIsButtonDisabled(false);
    } else {
      (!promo || !email) ? setIsButtonDisabled(true) : setIsButtonDisabled(false);
    }
    setError({ ...error, formError: "" })
  }, [email, promo])

  useEffect(() => {
    if (error.promo)
      setError({ ...error, promo: "" });

    setPromoValid(false);
  }, [promo])

  return (
    <>
      {state.settings.show_promo_popup === 'true' && showOnboardingAnimation && <OnboardingAnimation isTrialUser={false}/>}
      <S.Container>
        <S.Wrapper>
          <S.Heading>Enter your details</S.Heading>
          <form onSubmit={handleSubmit}>
            <FormElement>
              <label>EMAIL ID</label>
              <InputBox>
                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
              </InputBox>
              {!!(error.email) && <S.MessageBox isError={!!(error.email)}>
                <p>{error.email}</p>
              </S.MessageBox>}
            </FormElement>
            { state.settings.show_promo_popup !== 'true' && 
              <>
                <FormElement>
                  <label>ENTER PROMO CODE</label>
                  <InputBox text_color={promoValid ? mintGreen : ""} >
                    <input type="text" value={promo} onChange={(e) => setPromo(e.target.value)} required />
                    <span onClick={validatePromoCode} className="link_style">{error.promo ? "Try Again" : (promoValid ? <S.ImageWrapper><Image src={tick} /> </S.ImageWrapper> : "Apply")}</span>
                  </InputBox>
                  {(!!(error.promo) || promoValid == true) && <S.MessageBox isError={!!(error.promo)}>
                    <p>{error.promo ? error.promo : (promoValid ? promoValidMessage : "")}</p>
                  </S.MessageBox>}
                </FormElement>
              </>
            }
            {!!(error.formError) && <S.MessageBox isError={!!(error.formError)} isFormError={!!(error.formError)}>
              <p>{error.formError}</p>
            </S.MessageBox>}
            <S.CTAButton isButtonDisabled={isButtonDisabled} campaignBasedCustomization={["redemption", "splashlearn_giftup"].includes(campaign_code)}>
              <a href='javaascript:void(0)' onClick={handleSubmit}>
                {state.settings?.button_text || 'Get Started'}
                {state.settings?.button_sub_text && <p>{state.settings.button_sub_text}</p>}
              </a>
            </S.CTAButton>
          </form>
        </S.Wrapper>
      </S.Container>

    </>
  )
}

export default Promo